import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { FactoryTable } from 'components/ui';
import { useBasicFormStore } from 'stores/local/forms/BasicFormStore';
import { useVerificationFormStore } from 'stores/local/forms/VerificationFormStore';
import { noop } from 'utils/noop';

import s from './Content.module.scss';

const Content: React.FC = () => {
  const store = useVerificationFormStore();
  const basicStore = useBasicFormStore();

  React.useEffect(() => {
    store.init();
  }, [store, basicStore.id]);

  return (
    <div className={s.content}>
      <FactoryTable
        expandIcon={noop}
        rowKey="uniqueId"
        pagination={false}
        tableStore={store.tableStore}
        virtual
      />
    </div>
  );
};

export default observer(Content);
